export const socialsData = {
    github: 'https://github.com/pranshu-tomer',
    facebook: 'https://www.facebook.com/',
    linkedIn: 'www.linkedin.com/in/pranshu-tomer',
    instagram: 'https://www.instagram.com/shadow_voltrex/',
    // codepen: 'https://codepen.io/',
    // twitter: 'https://twitter.com/',
    // reddit: 'https://www.reddit.com/user/',
    // blogger: 'https://www.blogger.com/',
    // medium: 'https://medium.com/@',
    // stackOverflow: 'https://stackoverflow.com/users/',
    // gitlab: 'https://gitlab.com/',
    // youtube: 'https://youtube.com/'
}